import { SUPPORTED_COUNTRY } from 'utils/constants';

import { config as AU } from './au/config';
import { config as CA } from './ca/config';
import { config as GB } from './gb/config';
import { config as IN } from './in/config';
import { config as JP } from './jp/config';
import { config as US } from './us/config';
// eu migration
import { config as BG } from './bg/config';
import { config as LT } from './lt/config';
import { SiteConfig } from './types';

const sites: Record<SUPPORTED_COUNTRY, SiteConfig> = {
  AU,
  CA,
  GB,
  IN,
  JP,
  US,
  // eu migration
  BG,
  LT,
};

export default sites;
